export default "__VITE_ASSET__BXE5wBAI__"